<template>
    <div>
        <div  class="container-fluid">
            <div class="layout-content">
                <div class="layout-main">
                    <div class="box-body text-center">
                            <p>
                                <img src="https://ms0.meituan.net/touch/css/i/404.png" alt="">
                            </p>
                            <p class="text-center">
                                你所访问的页面不存在
                                <a href="/" class="btn">返回首页</a>
                            </p>
                    </div>
                </div>
            </div>
        </div>
        <footer-bar></footer-bar>
    </div>
</template>
<script>
import { NavBar, FooterBar } from 'components/layout'
export default {
    components: {
        NavBar,
        FooterBar
    },
    methods: {

    },
    data () {
        return {}
    }
}
</script>

<style lang="css" scoped>
.box-body {
    margin: 15%;
}
</style>



// WEBPACK FOOTER //
// 404.vue?b5e18788